import { render, staticRenderFns } from "./InspectRecord.vue?vue&type=template&id=5da56c2f&scoped=true"
import script from "./InspectRecord.vue?vue&type=script&lang=js"
export * from "./InspectRecord.vue?vue&type=script&lang=js"
import style0 from "./InspectRecord.vue?vue&type=style&index=0&id=5da56c2f&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da56c2f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5da56c2f')) {
      api.createRecord('5da56c2f', component.options)
    } else {
      api.reload('5da56c2f', component.options)
    }
    module.hot.accept("./InspectRecord.vue?vue&type=template&id=5da56c2f&scoped=true", function () {
      api.rerender('5da56c2f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/page/inspect/InspectRecord.vue"
export default component.exports